/* ======= All App File Include Here ======= */
// Vuetify Css
import 'vuetify/dist/vuetify.css'

// Editor Css
import 'vue-wysiwyg/dist/vueWysiwyg.css'

// nprogress
import 'nprogress/nprogress.css'

// Icons
//import '../assets/themify-icons/themify-icons.css'


// Slick Slider
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

// animate css
import '../assets/animate.css';

// Global Scss File
import '../assets/scss/_style.scss'